import React from 'react';
import { Helmet } from 'react-helmet-async';

const OG_IMAGE = 'https://customer-assets.emergentagent.com/job_130b504f-d356-4ffc-9f88-b9ceecab1da1/artifacts/djtji90d_logo_large%20-%20Edited.png';

const SEOHead = ({ title, description, keywords, url, type = 'website', image, article }) => {
  const fullUrl = `https://closenowlending.com${url}`;
  const ogImage = image || OG_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Article-specific */}
      {article && <meta property="article:published_time" content={article.publishedTime} />}
      {article && <meta property="article:author" content={article.author} />}
      {article?.tags?.map((tag, i) => (
        <meta key={i} property="article:tag" content={tag} />
      ))}
    </Helmet>
  );
};

export default SEOHead;
